import { withPluginApi } from "discourse/lib/plugin-api";
import richEditorExtension from "../lib/disable-indented-code-rich-editor";

export default {
  name: "disable-indented-code-block",

  initialize() {
    withPluginApi((api) => {
      api.registerRichEditorExtension(richEditorExtension);
    });
  },
};
